import * as React from 'react';
import { Box } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { SyntheticEvent } from 'react';
import NutzerListe from './UserList';
import NewUser from './NewUser';

interface ITabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props:ITabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {/* <Typography> */}
          {children}
          {/* </Typography> */}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index:number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Nutzerverwaltung() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event:SyntheticEvent<Element, Event>, newValue:number) => {
    setValue(newValue);
  };

  return (
    <>
      <Container component="main" >
      <Typography sx={{ maxWidth: '100%', typography: { xs: 'h4', md: 'h3' } }}>Nutzerverwaltung</Typography>

        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" scrollButtons variant='scrollable' allowScrollButtonsMobile sx={{ width: "100%" }}>
              <Tab label="Nutzerverwaltung" {...a11yProps(0)} />
              <Tab label="Nutzer einladen" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={1}>
            <NewUser/>
          </TabPanel>
          <TabPanel value={value} index={0}>
            <Box>
              <NutzerListe  ></NutzerListe>
            </Box>
          </TabPanel>

        </Box>


      </Container>

    </>
  );
}





